import styled from 'styled-components';

export const TableHeader = styled.thead`
  &:first-child {
    border-bottom: ${({ theme, customBorder }) => customBorder || `2px solid ${theme.iconColor}`};
  }
`;
